import { render, staticRenderFns } from "./lucroLiquidoInfoMobile.vue?vue&type=template&id=21366771&scoped=true&"
import script from "./lucroLiquidoInfoMobile.vue?vue&type=script&lang=js&"
export * from "./lucroLiquidoInfoMobile.vue?vue&type=script&lang=js&"
import style0 from "./lucroLiquidoInfoMobile.vue?vue&type=style&index=0&id=21366771&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21366771",
  null
  
)

export default component.exports